import MessageCard from './view';

export default MessageCard;
